var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "e-circular create-ecircular" },
    [
      _vm.showHeader
        ? _c("TMSHeader", {
            attrs: {
              buttons: _vm.buttons,
              dotOption: _vm.dotOption,
              title: _vm.currentECircular.subject,
              status: _vm.currentECircular.status,
            },
          })
        : _vm._e(),
      _vm._v(" "),
      _c("div", { staticClass: "create-ecircular-form main-content__box" }, [
        _c("div", { staticClass: "one-row" }, [
          _c(
            "div",
            {
              class: [
                "category",
                { "required-error-highlight": _vm.noCategory },
              ],
            },
            [
              _c("label", { class: { "required-flag": _vm.canEdit } }, [
                _vm._v(_vm._s(_vm.$t("eCircular.category"))),
              ]),
              _vm._v(" "),
              _vm.canEdit
                ? _c("HKLSelect", {
                    attrs: {
                      options: _vm.categoryHklOptions,
                      value: _vm.currentCategoryId,
                      placeholder: "",
                      showSearch: true,
                    },
                    on: { change: _vm.onCategoryChange },
                  })
                : _c("span", [_vm._v(_vm._s(_vm.displayCategory))]),
            ],
            1
          ),
          _vm._v(" "),
          !_vm.isVendorEcircular
            ? _c(
                "div",
                {
                  class: [
                    "building",
                    { "required-error-highlight": _vm.noBuildings },
                  ],
                },
                [
                  _c("label", { class: { "required-flag": _vm.canEdit } }, [
                    _vm._v(_vm._s(_vm.$t("eCircular.building"))),
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    { key: _vm.timestamp },
                    [
                      _vm.canEdit
                        ? _c("HKLMultiSelect", {
                            staticClass: "multi-value",
                            attrs: {
                              options: _vm.buildingHklOptions,
                              value: _vm.selectedBuildings,
                              placeholder: "",
                              disabled: _vm.buildingDisabled,
                            },
                            on: { change: _vm.onBuildingsChange },
                          })
                        : _c("span", [
                            _vm._v(
                              _vm._s(
                                _vm.getSelectBuildings() || _vm.$t("emptyValue")
                              )
                            ),
                          ]),
                    ],
                    1
                  ),
                ]
              )
            : _vm._e(),
          _vm._v(" "),
          _c("div", { class: _vm.canEdit ? "identifier-edit" : "identifier" }, [
            _c("label", [_vm._v(_vm._s(_vm.$t("eCircular.no")))]),
            _vm._v(" "),
            _c("pre", [_vm._v(_vm._s(_vm.currentECircular.code))]),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "selected-user-type" }, [
            _c("label", [_vm._v(_vm._s(_vm.$t("eCircular.userType")))]),
            _vm._v(" "),
            _c("pre", [_vm._v(_vm._s(_vm.displaySelectedUserType))]),
          ]),
        ]),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "textarea input-row subject",
            class: {
              edit: _vm.canEdit,
              noSubject:
                !_vm.currentECircular.subject && _vm.checkState.subject,
            },
          },
          [
            _c("label", { class: { "required-flag": _vm.canEdit } }, [
              _vm._v(_vm._s(_vm.$t("eCircular.subject"))),
            ]),
            _vm._v(" "),
            _vm.canEdit
              ? _c("TextField", {
                  attrs: {
                    label: "",
                    showColon: false,
                    value: _vm.currentECircular.subject,
                    required: true,
                  },
                  on: { updateValue: _vm.updateSubject },
                })
              : _c("pre", [_vm._v(_vm._s(_vm.currentECircular.subject))]),
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "description input-row" },
          [
            _c(
              "label",
              { class: { "required-flag": _vm.canEdit && _vm.isDescRequired } },
              [_vm._v(_vm._s(_vm.$t("description")))]
            ),
            _vm._v(" "),
            _vm.canEdit
              ? _c("TinymceEditor", {
                  attrs: {
                    invalidInput: _vm.checkNoDescription,
                    imgSourceId: _vm.currentECircular.imgSourceId,
                    additionalToolbar: [
                      "hklBulletBList hklNumberedList",
                      "image",
                      "link unlink",
                      "fontselect fontsizeselect",
                      "superscript subscript",
                    ],
                  },
                  model: {
                    value: _vm.description,
                    callback: function ($$v) {
                      _vm.description = $$v
                    },
                    expression: "description",
                  },
                })
              : _c("ECircularPreviewIndex"),
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            class: [
              "signature input-row",
              { "required-error-highlight": _vm.noSignature },
            ],
          },
          [
            _c("label", { class: { "required-flag": _vm.canEdit } }, [
              _vm._v(_vm._s(_vm.$t("footer"))),
            ]),
            _vm._v(" "),
            _vm.canEdit && _vm.signatureTemplatesOptions.length > 1
              ? _c("HKLSelect", {
                  attrs: {
                    options: _vm.signatureHklOptions,
                    value: _vm.currentECircular.signatureId,
                    placeholder: "",
                  },
                  on: { change: _vm.onSignatureChange },
                })
              : _vm._e(),
            _vm._v(" "),
            !_vm.canEdit || _vm.signatureTemplatesOptions.length <= 1
              ? _c("p", { staticClass: "small-6" }, [
                  _vm._v(
                    "\n        " +
                      _vm._s(
                        (_vm.signatureTemplate || {}).title ||
                          _vm.$t("emptyValue")
                      ) +
                      "\n      "
                  ),
                ])
              : _vm._e(),
            _vm._v(" "),
            (_vm.signatureTemplate || {}).content && _vm.canEdit
              ? _c("div", {
                  key: new Date().getTime(),
                  staticClass: "clearfix content",
                  domProps: {
                    innerHTML: _vm._s((_vm.signatureTemplate || {}).content),
                  },
                })
              : _vm._e(),
          ],
          1
        ),
        _vm._v(" "),
        _vm.canEdit || _vm.attachmentsLength
          ? _c(
              "div",
              { staticClass: "attachments input-row" },
              [
                _c("label", [_vm._v(_vm._s(_vm.$t("attachments")))]),
                _vm._v(" "),
                _vm.canEdit
                  ? _c("FileUpload", {
                      attrs: {
                        initLoading: false,
                        attachment: _vm.attachments,
                        resourceId: _vm.ecircularId,
                        uploadDocTypes:
                          _vm.eCircularAttachmentLimits.docUploadTypes,
                        maxNumberOfFiles:
                          _vm.eCircularAttachmentLimits.maxFiles,
                        maxTotalFileSizeInBytes:
                          _vm.eCircularAttachmentLimits.maxTotalSizeBytes,
                        uploadNoteRows: _vm.eCircularAttachmentNoteRows,
                        filesExceedMessage: _vm.eCircularFilesExceedMessage,
                        totalSizeExceedMessage:
                          _vm.eCircularTotalSizeExceedMessage,
                        useTotalSizeMessageForFileSizeError: true,
                      },
                      on: {
                        "update:attachment": function ($event) {
                          _vm.attachments = $event
                        },
                      },
                    })
                  : _c("EditAttachments", {
                      attrs: {
                        canEdit: false,
                        canDelete: false,
                        sourceId: _vm.currentECircular.id,
                        canDownloadAll: true,
                        zipName:
                          _vm.currentECircular.subject +
                          "_eCircular_Documents.zip",
                      },
                    }),
              ],
              1
            )
          : _vm._e(),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "date-time" },
          [
            _c("label", [_vm._v(_vm._s(_vm.$t("eCircular.scheduleDateTime")))]),
            _vm._v(" "),
            _vm.canEdit
              ? _c("DateTimeSelector", {
                  key: _vm.timestamp,
                  attrs: {
                    timeOptions: _vm.scheduleTimeOptions,
                    date: _vm.currentECircular.scheduleDate,
                    showClearBtn: true,
                    setMinTime: true,
                    disabledDates: { to: _vm.yesterday },
                    disabled: "",
                  },
                  on: {
                    updateDate: _vm.updateScheduleDate,
                    "update:partialSelected": _vm.updateTimeOptions,
                  },
                })
              : _c("div", [
                  _vm._v(
                    "\n        " +
                      _vm._s(
                        _vm.formatDate(_vm.currentECircular.scheduleDate)
                      ) +
                      "\n      "
                  ),
                ]),
          ],
          1
        ),
      ]),
      _vm._v(" "),
      _c("CancelECircular", { ref: "cancelModal" }),
      _vm._v(" "),
      _c("ActionConfirmModal", {
        ref: "buildingChangedConfirmation",
        attrs: {
          modalId: "buildingChangedConfirmation",
          confirmTitle: _vm.$t("eCircular.buildingChangedConfirmation"),
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }